import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, reactive, watch, onMounted } from 'vue'
    import { guid } from '@common/Guid'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminManageDatasetsPage } from '@Integrations/Datasets/pages-core'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AdminManageDatasetsPage',
  setup(__props) {

    document.title = "Manage datasets"

    const tid = useOrganizationUnitId()

    const { useCurrentUserQuery, useDatasetsOfOrganizationQuery, useCreateDatasetCommand } = useAdminManageDatasetsPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { modelDatasetsOfOrganizationQueryV1, runDatasetsOfOrganizationQueryV1 } = useDatasetsOfOrganizationQuery(tid)
    const datasets = computed(() => modelDatasetsOfOrganizationQueryV1.value?.Datasets || [])

    const { invokeCreateDatasetCommandV1, succeedCreateDatasetCommandV1 } = useCreateDatasetCommand(() => guid(), tid, userId, null)

    onMounted(() => {
        runCurrentUserQueryV1()
        runDatasetsOfOrganizationQueryV1()
    })

    watch(succeedCreateDatasetCommandV1, () => runDatasetsOfOrganizationQueryV1())

    function handleCreateDatasetCommandV1() {
        const name = prompt('Enter a new dataset name')
        if (name) { invokeCreateDatasetCommandV1({ Name: name }) }
    }

return { __sfc: true,tid, useCurrentUserQuery, useDatasetsOfOrganizationQuery, useCreateDatasetCommand, modelCurrentUserQueryV1, runCurrentUserQueryV1, userId, modelDatasetsOfOrganizationQueryV1, runDatasetsOfOrganizationQueryV1, datasets, invokeCreateDatasetCommandV1, succeedCreateDatasetCommandV1, handleCreateDatasetCommandV1 }
}

})